module.exports = __webpack_public_path__ + "media/images/logos/simrad-d744efa9f3b13a7288bb118b4d82a471.png";